document.addEventListener("DOMContentLoaded", () => {
  try {
    // --- Geo Detection (En güvenli şekilde üç farklı yöntem)
    const country =
      (window.Shopify && Shopify.country) ||   // Shopify automatic geo
      (window.Shopify && Shopify.locale) ||    // Fallback locale
      (window.navigator && navigator.language); // Browser language fallback

    // Korea kontrolü (KR, KO-KR, ko gibi tüm varyasyonları yakalar)
    const isKorea =
      country === "KR" ||
      country === "ko" ||
      (typeof country === "string" && country.toLowerCase().includes("kr")) ||
      (typeof country === "string" && country.toLowerCase().includes("ko"));

    if (!isKorea) return;

    // --- Element Selection (ID bozulsa bile çalışır)
    const el =
      document.querySelector("#shopify-section-sections--24631059218725__header_announcements_jcFdtz") || // mevcut ID
      document.querySelector('[id*="header_announcements"]') ||   // ID içinde "header_announcements" varsa
      document.querySelector(".header-announcement") ||            // class fallback
      document.querySelector(".announcement-bar");                 // Shopify default

    if (el) el.style.display = "none";

  } catch (e) {
    console.error("Geo hide script error:", e);
  }
});


async function customizeShippingText() {
    try {
        console.log("Noka Shipping Script: Checking location...");

        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        const countryCode = data.country_code;
        const countryNameDetect = data.country_name;
        const continent = data.continent_code; 
        console.log(`Noka Shipping Script: Detected Location -> ${countryNameDetect} (${countryCode})`);

      
        const shippingElement = document.querySelector("#ProductInformation-template--24634371637541__main > div.group-block.group-block--height-.group-block--width-fill.border-style.spacing-style.size-style > div.group-block-content.layout-panel-flex.layout-panel-flex--column > div.accordion.accordion--AUlhuYlR2YUo2US8vS__accordion_X7wqHK.accordion--plus.border-style.spacing-style.color-scheme-2.accordion--dividers > accordion-custom:nth-child(2) > details > div > rte-formatter");

        if (!shippingElement) {
            console.error("Noka Shipping Script: Element not found.");
            return;
        }

        if (continent === 'EU' || countryCode === 'GB') {
            
        
            const countryName = (countryCode === 'GB') ? 'the UK' : countryNameDetect;
            
            shippingElement.innerHTML = `
                <p><strong>FREE express shipping to ${countryName}</strong></p>
                <p>With express shipping, 94% of our Noka shipments are delivered to our customers in ${countryName} within 5-7 business days.</p>
                <p style="font-size: 0.9em; color: #666;"><em><strong>Note:</strong> Express shipping is only available for Noka. For furniture and larger items, shipping times may vary due to their size and nature. For details, please see our <a href="/pages/shipping-policy">Shipping Policy</a> page.</em></p>
            `;
            console.log(`Noka Shipping Script: Updated for ${countryName} with furniture disclaimer.`);
        } else {
            console.log("Noka Shipping Script: Visitor is outside of Europe/UK.");
        }
    } catch (error) {
        console.error('Noka Shipping Script Error:', error);
    }
}

document.addEventListener('DOMContentLoaded', customizeShippingText);